import { useAccount } from 'wagmi'
import { useLidoSDK, useGasFeeUSD } from '.'
import { Address, parseEther } from 'viem'
import { ESTIMATE_ACCOUNT } from '../constants'
import useSWR from 'swr'
import { useDebounce } from '~/hooks/useDebounce'
import { REFERRAL_ADDRESS, FALLBACK_STAKE_GAS_LIMIT } from '../constants'
import {
  LidoSDKStake,
  GAS_TRANSACTION_RATIO_PRECISION,
  SUBMIT_EXTRA_GAS_TRANSACTION_RATIO,
} from '@lidofinance/lido-ethereum-sdk'

const fetchStakeGasLimit = async (
  stake: LidoSDKStake,
  value: bigint,
  account: Address,
) => {
  try {
    const contract = await stake.getContractStETH()
    // @ts-ignore
    const originalGasLimit = await contract.estimateGas.submit(
      [REFERRAL_ADDRESS],
      { account, value },
    )

    const gasLimit =
      (originalGasLimit *
        BigInt(
          GAS_TRANSACTION_RATIO_PRECISION * SUBMIT_EXTRA_GAS_TRANSACTION_RATIO,
        )) /
      BigInt(GAS_TRANSACTION_RATIO_PRECISION)
    return gasLimit
  } catch (error) {
    return FALLBACK_STAKE_GAS_LIMIT
  }
}

export const useStakeGasFee = (amount: string) => {
  const { address: userAccount } = useAccount()
  const account = (userAccount ?? ESTIMATE_ACCOUNT) as Address
  const { stake } = useLidoSDK()
  const debouncedAmount = useDebounce(amount || '0.01', 500)
  const formattedAmount = parseEther(debouncedAmount)
  const { data } = useSWR(
    ['lido-stake-gas-limit', formattedAmount, account],
    () => fetchStakeGasLimit(stake, formattedAmount, account),
    {
      refreshInterval: 60000,
    },
  )

  const gasLimit = data ?? FALLBACK_STAKE_GAS_LIMIT

  const { gasFee, gasFeeUSD } = useGasFeeUSD(gasLimit)

  return { gasLimit, gasFee, gasFeeUSD }
}
